import { createContext } from 'react';
import { INITIAL_USER } from '../constants.js';

const UserContext = createContext(INITIAL_USER);

export default UserContext;
